import MapHandler from "../../map/MapHandler";
import MapPaintHandler from "../../map/MapPaintHandler";

export default class MapPainter {
  #painthandler;
  #lastPos = "";
  constructor(painthandler: MapPaintHandler) {
    this.#painthandler = painthandler;
  }
  onAddObject(evt: any, maphandler: MapHandler) {
    const map = maphandler.getMap();

    maphandler.setPainterCallbackAtMapMove(() => {
      this.#painthandler.triggerAtMapMove();
    });
    this.#painthandler.setMap(map);
    this.#painthandler.addCoordinates(evt.symbolId, evt.xPos, evt.yPos);
    this.#lastPos = evt.xPos + "-" + evt.yPos;
  }

  onUpdateObject(evt: any) {
    if (evt.xPos + "-" + evt.yPos !== this.#lastPos) {
      this.#painthandler.addCoordinates(evt.symbolId, evt.xPos, evt.yPos);
      this.#lastPos = evt.xPos + "-" + evt.yPos;
    }
  }

  onRemoveObject(evt: any) {
    this.#painthandler.finishDrawing(evt.symbolId);
  }
}
